package com.milta.core.localization.translations.pl

import com.milta.core.localization.SettingsStrings

internal val Settings = SettingsStrings(
    profileSectionTitle = "PROFIL ORGANIZACJI",
    profileNameLabel = "Nazwa organizacji",
    languageSectionTitle = "JĘZYK INTERFEJSU",
    languageSearchPlaceholder = "Szukaj języka...",
    languageMoreAvailable = "%d innych dostępnych języków",
    languageErrorGeneric = "Wystąpił błąd. Spróbuj ponownie.",
    subscriptionSectionTitle = "SUBSKRYPCJA",
    subscriptionPlanLabel = "Plan",
    subscriptionBillingLabel = "Rozliczenia",
    subscriptionRenewalLabel = "Następne odnowienie",
    subscriptionBillingMonthly = "Miesięczne",
    subscriptionBillingAnnual = "Roczne",
    subscriptionPlanOrganisationLabel = "Organizacja (Menedżer + zespół)",
    subscriptionPriceSuffix = "netto / miesiąc",
    subscriptionUnavailable = "Niedostępne",
    deleteSectionTitle = "Usuń organizację",
    deleteWarning = "Ta czynność jest trwała i nieodwracalna.",
    deleteDescription = "Trasy i dowody dostawy zostaną usunięte. Konta kierowców zostaną odłączone od organizacji, ale nigdy nie zostaną usunięte.",
    deleteConfirmLabel = "Aby potwierdzić, wpisz nazwę organizacji",
    deleteButton = "Usuń trwale",
    deleteFinalDialogTitle = "Potwierdzić trwałe usunięcie?",
    deleteFinalDialogMessage = "Tej czynności nie można cofnąć. Organizacja, jej trasy i dowody dostawy zostaną trwale usunięte.",
    deleteErrorGeneric = "Wystąpił błąd. Spróbuj ponownie.",
)
